import { useTaskStore } from "../stores/taskStore";

export function FilterBar() {
  const filter = useTaskStore((s) => s.filter);
  const labels = { today: "今日", active: "未完了", all: "全部", completed: "完了", high: "高優先", trashed: "ゴミ箱" };
  return <div className="px-8 pb-2 text-xs font-medium text-muted dark:text-muted-dark">{labels[filter]}</div>;
}
